import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  getUsersListSuccess,
  getUsersListFailure,
} from "../../Action/auth/getUsersListAction";
import { GET_USERS_LIST } from "../../Action/actionTypes";

function* getUsersListRequest(action) {

  try {

    const { currentPage, rowCount, whiteLabelID, roleFilter,debouncedQuery,roleType } = action?.payload?.payload;
    const { data } = yield API.get(`/getuserslist?currentPage=${currentPage}&rowCount=${rowCount}&whiteLabelID=${whiteLabelID}&roleFilter=${roleFilter}&search=${debouncedQuery}&roleType=${roleType}`);
  

    if (data?.meta?.code === 200) {
      yield put(getUsersListSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(getUsersListFailure());
    }
  } catch (error) {
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
    yield put(getUsersListFailure());
  }
}

export function* watchGetUsersListAPI() {
  yield takeEvery(GET_USERS_LIST, getUsersListRequest);
}

export default function* rootSaga() {
  yield all([watchGetUsersListAPI()]);
}
